import D2C_KeySSH from './SSH'
import D2C_KeySFTP from './SFTP'

export default {
  KeySSH: D2C_KeySSH,
  KeySFTP: D2C_KeySFTP,
}
